module.exports = __webpack_public_path__ + "img/picker-self-off.ef0a74f6.png";